<div class="task">
  <h2>
    <a [uiParams]="{id: data.workflow.object.id}" ngbTooltip="Zurück zum Vorgang" uiSref="a.workflow.detail">
      <i class="fa fa-chevron-left"></i>
      Vorgang: {{ data.workflow.object.id }}
    </a>
  </h2>

  <h1>Auftragsbestätigung erstellen</h1>

  <div class="row">
    <div class="col-md-8">
      @if (data.workflow.frame) {
        <contract-create-additional (saveEmitter)="updateAdditionalForm($event)"
          [additional]="data.additional"
          [addresses]="data.address"
          [contractList]="data.contract_list.objects"
          [lastOffer]="data.last_offer"
          [workflow]="data.workflow">
        </contract-create-additional>
      }

      @if (!data.workflow.frame?.approval) {
        <div class="row">
          <div class="col-sm-12 btn-group simple-margin">
            @if (data.workflow.frame && !data.workflow.frame?.approval) {
              <div class="red_alert height-20">
                Bitte warten Sie bis der Auftragsrahmen bestätigt wurde!
              </div>
            }
            @if (!data.workflow.frame) {
              <button (click)="addFrame()" class="btn btn-default btn-sm">
                Auftragsrahmen erstellen
              </button>
            }
          </div>
        </div>
      }

      @if (data.workflow.frame?.approval) {
        <contract-create-form (triggerPrice)="triggerPrice()"
          (updateList)="updateList()"
          [inputForm]="additionalFormData"
          [workflow]="data.workflow"
          [article]="data.article"
          [priceIncreaseFlex]="data.price_increase_flex">
        </contract-create-form>
      }

      <div class="row">
        <div class="col-md-12">
          <article-warning [article]="data.article"></article-warning>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          Nur Positionen die noch nicht bestätigt wurden und ein Liefertermin eingetragen haben, werden auf
          der Auft.-Best. bestätigt.
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <a [uiParams]="{id: data.workflow.object.id}" class="btn btn-default" uiSref="a.workflow.detail">
            Zurück zur Übersicht
          </a>
        </div>

        <div class="col-md-10">
          <customer-credit-worthiness-alert [customerCredit]="data.customer_credit_worthiness">
            <ng-template>
              <loading-button (loadingSave)="create($event)"
                [disabled]="createLocked"
                clazz="btn btn-success pull-right">
                Auf.-Best. erstellen
              </loading-button>
            </ng-template>
          </customer-credit-worthiness-alert>
        </div>
        <workflow-position-missing-gold-price labelHeader="Artikel aus Auf.-Best. hat die Oberfläche &quot;Chem NI/AU&quot;,
         aber es gibt keine Goldpreis Position auf der Auf.-Best."
                                              labelCheckbox="Auftragsbestätigung trotzdem erstellen"
                                              labelButton="Auf.-Best. erstellen"
                                              [modalOpen]="showGoldPriceMissingModal"
                                              (response)="handleGoldPriceMissingModalClose($event)">
        </workflow-position-missing-gold-price>
      </div>

    </div>

    <div class="col-md-4">
      <contract-create-list [article]="data.article"
        [contractList]="$safeNavigationMigration(data.contract_list?.objects)"
        [lastOffer]="data.last_offer"
        [workflow]="data.workflow"
        [priceIncreaseFlex]="data.price_increase_flex"
        (updatePriceIncreaseFlex)="updatePriceIncreaseFlex($event)">
      </contract-create-list>
    </div>
  </div>

</div>
